import { useNavigate } from 'react-router-dom'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { UserManagement } from '@/components/settings/UserManagement'
import { Breadcrumb } from '@/components/ui/Breadcrumb'
import { Settings, Users } from 'lucide-react'

export function UsersPage() {
  const navigate = useNavigate()
  
  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Breadcrumb */}
        <Breadcrumb
          items={[
            { label: 'Settings', href: '/settings', icon: <Settings className="w-4 h-4" /> },
            { label: 'User Management', icon: <Users className="w-4 h-4" /> }
          ]}
        />
        
        <UserManagement onBack={() => navigate('/settings')} />
      </div>
    </DashboardLayout>
  )
}